function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 13.5,
  stroke: "#2F3947",
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.25
});

var SvgCircleBorder = function SvgCircleBorder(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='28px' height='28px' viewBox='0 0 28 28' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' opacity='0.25'%3E %3Cg transform='translate(-28.000000, -941.000000)' stroke='%232F3947'%3E %3Cg transform='translate(28.000000, 895.000000)'%3E %3Cg transform='translate(0.000000, 46.000000)'%3E %3Cg%3E %3Ccircle cx='14' cy='14' r='13.5'%3E%3C/circle%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgCircleBorder as ReactComponent };